import graphql__5c7d8632c46452ab095e from "./__generated__/ProfileEdition_user.graphql.js";
import graphql__8d3716b53b40353899e5 from "./__generated__/ProfileEdition_authenticationConfig.graphql.js";import { graphql, useFragment } from "react-relay";
import { defineMessages } from "react-intl";

import Button from "../Buttons/Button";
import ProfileEditionForm from "./ProfileEditionForm";
import ProfileAnonymizationForm from "./ProfileAnonymizationForm";
import HintBlock from "../Utils/HintBlock";
import { useFormatMessage } from "../Intl/Context";

import { signOut } from "../../mutations/SignOutMutation";

const ProfileEdition = props => {
  const user = useFragment(ProfileEdition_user, props.user);
  const authenticationConfig = useFragment(
    ProfileEdition_authenticationConfig,
    props.authenticationConfig
  );

  const t = useFormatMessage();
  const labels = {
    title: t(intlMessages.title),
    signOutTitle: t(intlMessages.signOutTitle),
    signOut: t(intlMessages.signOut),
    editEmailMessage: t(intlMessages.editEmailMessage),
    unconfirmedEmailPendingHint: t(intlMessages.unconfirmedEmailPendingHint, {
      email: <b>{user.unconfirmedEmail}</b>
    })
  };

  const handleSignOutButtonClicked = () => {
    signOut(handleSignOutResponse);
  };

  const handleSignOutResponse = ({ signOut }) => {
    const redirectUrl = signOut?.redirectUrl || "/";
    window.location.href = redirectUrl;
  };

  return (
    <>
      {user.unconfirmedEmail && (
        <HintBlock size="sm" colorClassName="warning">
          {labels.unconfirmedEmailPendingHint}
        </HintBlock>
      )}

      <div className="box padding-lg">
        <div className="row">
          <div className="col-12">
            <h2 className="text-subtitle-page margin-bottom-sm">{labels.title}</h2>

            <p dangerouslySetInnerHTML={{ __html: labels.editEmailMessage }} />

            <ProfileEditionForm user={user} authenticationConfig={authenticationConfig} />

            <div className="border-top margin-top-md">
              <h2 className="text-subtitle-page margin-y-sm">{labels.signOutTitle}</h2>
              <Button
                className="btn btn-primary btn-md margin-top-sm"
                onClick={handleSignOutButtonClicked}
                label={labels.signOut}
                iconClassName="icon-suppr"
              />
            </div>

            <ProfileAnonymizationForm user={user} />
          </div>
        </div>
      </div>
    </>
  );
};

const ProfileEdition_user = graphql__5c7d8632c46452ab095e;

const ProfileEdition_authenticationConfig = graphql__8d3716b53b40353899e5;

export default ProfileEdition;

const intlMessages = defineMessages({
  title: {
    id: "profile.edit.title",
    defaultMessage: "Complétez votre profil"
  },
  signOutTitle: {
    id: "profile.edit.signOutTitle",
    defaultMessage: "Déconnexion"
  },
  signOut: {
    id: "profile.edit.signOut",
    defaultMessage: "Se déconnecter"
  },
  editEmailMessage: {
    id: "profile.edit.editEmailMessage",
    defaultMessage: `
    Si vous souhaitez changer d'adresse e-mail, vous devrez confirmer
    votre nouvelle adresse via un lien qui vous sera envoyé sur la nouvelle
    adresse e-mail.
    `
  },
  unconfirmedEmailPendingHint: {
    id: "profile.edit.unconfirmedEmailPendingHint",
    defaultMessage: `
    Votre nouvelle adresse e-mail {email} est en attente de confirmation.
    Merci de la confirmer à l'aide du lien qui vous a été envoyé sur votre nouvelle adresse e-mail.
    `
  }
});
